// extracted by mini-css-extract-plugin
module.exports = {"body-copy":"SideBySideMediaText_body-copy__my2fj","Button":"SideBySideMediaText_Button__gNmiM"};